import site from '../../site';

const getCurrentLocale = (state) => {
  const activePageId = site.selectors.getActivePageId(state);
  const activePage = site.selectors.getPage(state, activePageId);

  if (!activePage) return null;

  return activePage.locale;
};

export default getCurrentLocale;
